// Wave 27 · V2 — Marriage Abroad & Cross-Border Family full-service hub
import type { KeywordFaqHubData } from "@/components/KeywordFaqHub";

export const MARRIAGE_ABROAD_HUB: KeywordFaqHubData = {
  eyebrowTh: "แต่งงานต่างประเทศ · 140+ คีย์เวิร์ด · ทนายและล่ามรับรอง",
  eyebrowEn: "Marriage Abroad Hub · 140+ keywords · Licensed lawyers & sworn interpreters",
  h1Th: "จดทะเบียนสมรสไทย–ต่างชาติ & แต่งงานต่างประเทศครบวงจร — เอกสารผ่าน 100% ทุกสถานทูต",
  h1En: "Thai–Foreign Marriage Registration & Cross-Border Wedding Services — 100% Embassy Pass Rate",
  introTh:
    "ทีมทนายและล่ามรับรองดูแลตั้งแต่ Affirmation of Freedom to Marry, การรับรองสถานะโสด (Single Status), แปลรับรอง MFA + Apostille, จดทะเบียนสมรสที่อำเภอไทย, แต่งงานที่สถานทูตต่างประเทศ (US, UK, Australia, Germany, France, Japan, Korea, China), Prenuptial Agreement, Divorce Recognition และการเปลี่ยนนามสกุลข้ามประเทศ ครอบคลุม 60+ สัญชาติ",
  introEn:
    "Licensed lawyers and sworn interpreters handle every step: Affirmation of Freedom to Marry, Single Status Certification, MFA-legalised translations + Apostille, Thai amphur registration, embassy weddings (US, UK, Australia, Germany, France, Japan, Korea, China), Prenuptial Agreements, Divorce Recognition, and cross-border name changes — covering 60+ nationalities.",
  chips: [
    { labelTh: "Marriage Hub", labelEn: "Marriage Home", toTh: "/marriage", toEn: "/en/marriage" },
    { labelTh: "US–Thai", labelEn: "US–Thai", toTh: "/marriage/american", toEn: "/en/marriage/american" },
    { labelTh: "UK–Thai", labelEn: "UK–Thai", toTh: "/marriage/british", toEn: "/en/marriage/british" },
    { labelTh: "German–Thai", labelEn: "German–Thai", toTh: "/marriage/german", toEn: "/en/marriage/german" },
    { labelTh: "Prenup", labelEn: "Prenup", toTh: "/prenuptial-agreement", toEn: "/en/prenuptial-agreement" },
    { labelTh: "K-1 Fiancé Visa", labelEn: "K-1 Fiancé Visa", toTh: "/visa-services/faq", toEn: "/en/visa-services/faq" },
  ],
  clusters: [
    {
      id: "affirmation-single-status",
      titleTh: "หนังสือรับรองสถานะโสด & Affirmation of Freedom to Marry",
      titleEn: "Single Status & Affirmation of Freedom to Marry",
      descTh:
        "ยื่นคำร้องที่สถานทูตต่างชาติในกรุงเทพ (US Embassy, UK, Germany, France, Netherlands, Australia) รับรองโดย MFA แจ้งวัฒนธรรม แปลไทยรับรอง — พร้อมล่ามในวันนัดหมาย รับ walk-in ที่ US Embassy ทุกวันจันทร์–พฤหัส 07:30",
      descEn:
        "Filed at foreign embassies in Bangkok (US, UK, Germany, France, Netherlands, Australia), MFA-legalised, then Thai-language sworn translation — with interpreters on the day. US Embassy walk-in Mon–Thu 07:30 supported.",
      keywords: [
        "affirmation of freedom to marry", "หนังสือรับรองสถานะโสด", "single status certificate thailand", "หนังสือรับรองโสด สถานทูต",
        "us embassy affirmation marry", "affirmation us embassy bangkok", "uk single status thailand", "certificate of no impediment thailand",
        "german ehefähigkeitszeugnis thailand", "ledigkeitsbescheinigung bangkok", "french certificat célibat", "netherlands single status thailand",
        "australian cnb thailand", "canadian single status certificate", "japanese koseki translation marriage", "korean marriage eligibility thailand",
        "affirmation notarize mfa apostille", "รับรองโสด mfa แจ้งวัฒนธรรม", "แปลรับรองโสด thai", "cno certificate embassy",
      ],
      linkTh: "/marriage", linkEn: "/en/marriage",
    },
    {
      id: "amphur-registration",
      titleTh: "จดทะเบียนสมรสที่อำเภอไทย (Thai Amphur)",
      titleEn: "Thai Amphur Marriage Registration",
      descTh:
        "ประสานงานล่วงหน้ากับ 878 อำเภอทั่วประเทศ — เตรียม คร.2, บันทึกข้อตกลง, ล่าม 3 ภาษา (อังกฤษ/จีน/ญี่ปุ่น/เกาหลี/เยอรมัน/ฝรั่งเศส) และแปลใบสมรส คร.3 คร.2 เป็นภาษาต่างประเทศพร้อม MFA/Apostille สำหรับใช้ต่างประเทศ",
      descEn:
        "Advance coordination with any of Thailand's 878 amphurs — Khor Ror 2 preparation, marriage agreements, on-site interpreters (EN/ZH/JA/KO/DE/FR), plus Khor Ror 2/3 translations with MFA + Apostille for foreign use.",
      keywords: [
        "amphur marriage registration bangkok", "จดทะเบียนสมรสที่อำเภอ", "khor ror 2 marriage certificate", "คร.2 คู่มือจดทะเบียนสมรส",
        "khor ror 3 family record", "คร.3 ทะเบียนครอบครัว", "interpreter amphur marriage", "ล่ามอำเภอจดทะเบียนสมรส",
        "bang rak amphur marriage foreigner", "อำเภอบางรัก จดทะเบียนสมรสต่างชาติ", "sathorn amphur marriage", "phuket amphur marriage foreigner",
        "chiang mai amphur marriage", "pattaya amphur marriage foreigner", "same-sex marriage thailand 2025", "จดทะเบียนสมรสเพศเดียวกัน 2568",
        "thai marriage certificate mfa translation", "แปลใบสมรส mfa รับรอง", "translate kor ror 2 english notarize", "apostille thai marriage certificate",
      ],
      linkTh: "/marriage", linkEn: "/en/marriage",
    },
    {
      id: "embassy-weddings",
      titleTh: "แต่งงานที่สถานทูต & จดทะเบียนต่างประเทศ",
      titleEn: "Embassy & Overseas Marriage Registration",
      descTh:
        "ประสานสถานทูตในกรุงเทพและกงสุลไทย (US Embassy walk-in, Australian consular marriage, German Standesamt-vor-Ort, Japanese kon-in todoke ที่กงสุลไทยในโตเกียว/โอซาก้า) — พร้อมรับรองใบสมรสกลับมาใช้ในไทยผ่าน MFA",
      descEn:
        "Coordination with Bangkok embassies and Thai consulates abroad — US Embassy walk-in, Australian consular marriage, German Standesamt-vor-Ort, Japanese kon-in todoke at Tokyo/Osaka Thai consulates — plus MFA legalisation of the foreign marriage certificate for Thai use.",
      keywords: [
        "us embassy wedding bangkok", "จดทะเบียนสมรสสถานทูตอเมริกา", "australian consular marriage thailand", "จดทะเบียนสมรสสถานทูตออสเตรเลีย",
        "japanese marriage registration kon-in todoke", "คนไทยแต่งงานที่ญี่ปุ่น", "korean marriage registration thailand", "จดทะเบียนสมรสเกาหลี",
        "german standesamt thailand", "จดทะเบียนสมรสเยอรมนี", "french mairie marriage thai", "แต่งงานฝรั่งเศส คนไทย",
        "vegas wedding certificate thailand", "จดทะเบียนสมรส เวกัส", "denmark marriage foreigner", "same-day marriage denmark thailand",
        "gibraltar marriage thai spouse", "cyprus marriage thai spouse", "hong kong marriage thai", "จดทะเบียนฮ่องกงคนไทย",
      ],
      linkTh: "/marriage", linkEn: "/en/marriage",
    },
    {
      id: "prenup-postnup",
      titleTh: "สัญญาก่อนสมรส (Prenup) & Postnuptial",
      titleEn: "Prenuptial & Postnuptial Agreements",
      descTh:
        "ร่างสัญญาสองภาษา (ไทย–อังกฤษ/เยอรมัน/ญี่ปุ่น/จีน) ให้บังคับใช้ได้ทั้งในไทยและต่างประเทศ — จดแนบท้ายทะเบียนสมรสที่อำเภอตามมาตรา 1465 ป.พ.พ. ครอบคลุมทรัพย์สินก่อนสมรส, มรดก, ธุรกิจครอบครัว, และเงื่อนไข choice of law",
      descEn:
        "Bilingual prenuptial and postnuptial contracts (Thai + English/German/Japanese/Chinese) enforceable both in Thailand and abroad — annexed to the marriage register per Section 1465 CCC. Covers separate property, inheritance, family businesses, and choice-of-law clauses.",
      keywords: [
        "prenuptial agreement thailand", "สัญญาก่อนสมรส", "prenup thai english bilingual", "ร่างสัญญาก่อนสมรส สองภาษา",
        "section 1465 ccc marriage", "มาตรา 1465 ป.พ.พ. สัญญาก่อนสมรส", "postnuptial agreement thailand", "สัญญาหลังสมรส",
        "prenup enforceable us thailand", "prenup us thai law", "prenup enforce germany thailand", "prenup deutschland thai",
        "prenup family business thailand", "prenup ธุรกิจครอบครัว", "prenup inheritance protection", "prenup ปกป้องมรดก",
        "prenup choice of law clause", "prenup ประเทศบังคับใช้", "prenup register amphur", "จดแนบท้ายทะเบียนสมรส",
      ],
      linkTh: "/prenuptial-agreement", linkEn: "/en/prenuptial-agreement",
    },
    {
      id: "divorce-recognition",
      titleTh: "การรับรองการหย่า & จดหย่าข้ามประเทศ",
      titleEn: "Divorce Recognition & Cross-Border Divorce",
      descTh:
        "รับรองคำพิพากษาหย่าจากต่างประเทศให้มีผลในไทย — แปลคำพิพากษารับรอง MFA, ยื่นบันทึกที่อำเภอ, ปรับปรุงทะเบียนครอบครัว (คร.3) และการหย่าที่กงสุลไทยในต่างประเทศ (uncontested divorce)",
      descEn:
        "Recognition of foreign divorce decrees in Thailand — MFA-legalised judgment translation, filing at the amphur, updating the Khor Ror 3 family record, plus uncontested divorces at Thai consulates abroad.",
      keywords: [
        "recognize foreign divorce thailand", "รับรองคำพิพากษาหย่าต่างประเทศ", "divorce judgment translation mfa", "แปลคำพิพากษาหย่า mfa",
        "us divorce recognize thailand", "หย่าอเมริกา บันทึกอำเภอ", "uk divorce absolute thailand", "decree absolute thai recognition",
        "german scheidungsurteil thailand", "japanese divorce rikon todoke thailand", "korean divorce thailand", "หย่าเกาหลี บันทึกไทย",
        "consular divorce uncontested", "หย่าที่สถานทูตไทย", "khor ror 6 divorce certificate", "คร.6 ใบหย่า",
        "amphur divorce foreigner", "จดหย่าที่อำเภอต่างชาติ", "divorce translation apostille thailand", "child custody cross border thailand",
      ],
      linkTh: "/marriage", linkEn: "/en/marriage",
    },
    {
      id: "post-marriage-family",
      titleTh: "หลังสมรส: เปลี่ยนนามสกุล, K-1/Spouse Visa, สัญชาติ",
      titleEn: "Post-Marriage: Name Change, K-1/Spouse Visa, Citizenship",
      descTh:
        "หลังจดทะเบียน — เปลี่ยนนามสกุลในทะเบียนบ้าน, แก้ passport, ยื่น K-1/CR-1 (US), Spouse visa UK/Australia, Family Reunification เยอรมนี, เตรียมเอกสารเพื่อขอสัญชาติไทย/สัญชาติต่างชาติสำหรับคู่สมรส",
      descEn:
        "Post-registration — surname change in the house register and passport, K-1/CR-1 (US), UK/AU Spouse Visa, German Family Reunification, and document preparation for Thai or foreign citizenship applications for the spouse.",
      keywords: [
        "change surname after marriage thailand", "เปลี่ยนนามสกุลหลังสมรส", "passport update after marriage", "แก้ passport หลังสมรส",
        "k-1 fiancé visa thailand", "k1 visa document translation", "cr-1 spouse visa us", "วีซ่าคู่สมรสอเมริกา cr1",
        "uk spouse visa financial requirement", "วีซ่าคู่สมรสอังกฤษ", "australian partner visa 820 801", "วีซ่าคู่สมรสออสเตรเลีย 820",
        "german family reunification visa", "วีซ่าติดตามคู่สมรสเยอรมนี", "japan spouse visa cor", "วีซ่าคู่สมรสญี่ปุ่น",
        "thai citizenship by marriage 3 years", "ขอสัญชาติไทยหลังสมรส", "thai id card after marriage foreigner", "ยล.3 ใบสำคัญประจำตัวคนต่างด้าว",
      ],
      linkTh: "/visa-services/faq", linkEn: "/en/visa-services/faq",
    },
  ],
  misspellings: [
    { wrong: "prenup thialand", right: "prenup Thailand" },
    { wrong: "amphure marriage", right: "amphur marriage" },
    { wrong: "khor ror2", right: "Khor Ror 2 (คร.2)" },
    { wrong: "affirmation marry us embasy", right: "affirmation to marry US Embassy" },
    { wrong: "cerficate of no impediment", right: "Certificate of No Impediment (CNI)" },
    { wrong: "ehefahigkeitszeugnis", right: "Ehefähigkeitszeugnis" },
    { wrong: "จดสมรสอำเพอ", right: "จดทะเบียนสมรสที่อำเภอ" },
    { wrong: "รับรองโสท", right: "รับรองโสด (Single Status)" },
  ],
  faqs: [
    {
      q: "ต่างชาติจดทะเบียนสมรสที่ไทยต้องใช้เอกสารอะไรบ้าง?",
      a: "3 อย่างหลัก — (1) หนังสือ Affirmation of Freedom to Marry / Single Status จากสถานทูตในกรุงเทพ (2) รับรองที่กรมการกงสุล MFA แจ้งวัฒนะ (3) แปลเป็นภาษาไทยรับรองแล้วยื่นที่อำเภอ พร้อม passport ตัวจริง ทั้งหมดใช้เวลา 3–5 วันทำการ",
    },
    {
      q: "What documents do foreigners need to marry in Thailand?",
      a: "Three items — (1) Affirmation of Freedom to Marry or Single Status from your embassy in Bangkok, (2) MFA legalisation at Chaeng Watthana, (3) Thai sworn translation filed at any amphur, with your original passport. Total timeline: 3–5 working days.",
    },
    {
      q: "US Embassy Bangkok เปิด walk-in วันไหน?",
      a: "จันทร์–พฤหัสบดี 07:30 (ไม่ต้องจอง) — ค่าธรรมเนียม 50 USD ชำระเป็นบาทตามเรทวันนั้น เอกสารรับใน 1 ชั่วโมงและใช้ยื่น MFA ได้เลย",
    },
    {
      q: "Same-sex marriage ในไทยจดได้แล้วหรือยัง?",
      a: "จดได้ตั้งแต่ 23 มกราคม 2568 (2025) ตามพระราชบัญญัติแก้ไข ป.พ.พ. — คู่รักเพศเดียวกันทั้งไทย–ไทย และไทย–ต่างชาติ ยื่นได้ที่ทุกอำเภอในไทยด้วยเอกสารชุดเดียวกับคู่ต่างเพศ",
    },
    {
      q: "Is same-sex marriage legal in Thailand now?",
      a: "Yes — since 23 January 2025 under the amended Civil and Commercial Code. Both Thai–Thai and Thai–foreign same-sex couples can register at any amphur nationwide with the same document set as opposite-sex couples.",
    },
    {
      q: "Prenup ไทยบังคับใช้ในต่างประเทศได้ไหม?",
      a: "ได้ ถ้าร่างเป็นสองภาษา (ไทย+ภาษาคู่สมรส) ระบุ choice of law ชัดเจน จดแนบท้ายทะเบียนสมรสตามมาตรา 1465 ป.พ.พ. และรับรอง MFA + Apostille ก่อนส่งไปประเทศปลายทาง — ศาลสหรัฐ, เยอรมัน, ออสเตรเลีย รับรองในทางปฏิบัติแล้ว",
    },
    {
      q: "Will a Thai prenup be enforceable in my home country?",
      a: "Yes, if drafted bilingually (Thai + partner's language), the choice-of-law clause is explicit, it is annexed to the amphur register per Section 1465 CCC, and MFA-legalised + Apostilled before shipping. US, German, and Australian courts have accepted them in practice.",
    },
    {
      q: "จดทะเบียนสมรสที่ไทยแล้ว จะเอาไปใช้ในประเทศตัวเองยังไง?",
      a: "แปลใบสมรส คร.2/คร.3 เป็นภาษาปลายทาง รับรอง MFA แจ้งวัฒนะ แล้วยื่น Apostille (ตั้งแต่ 15 ธ.ค. 2568 ไทยเป็นภาคี Hague แล้ว) — ประเทศส่วนใหญ่รับใน 1–3 สัปดาห์",
    },
    {
      q: "How do I use my Thai marriage certificate in my home country?",
      a: "Translate Khor Ror 2/3 into the target language, MFA-legalise at Chaeng Watthana, then Apostille (Thailand joined the Hague Convention 15 Dec 2025). Most countries accept it within 1–3 weeks.",
    },
    {
      q: "หย่าที่อเมริกาแล้ว ต้องมาบันทึกที่ไทยไหม?",
      a: "ต้องบันทึก ถ้าคุณเคยจดที่อำเภอไทย — แปลคำพิพากษา (Final Judgment / Decree Absolute) รับรอง MFA และยื่นที่อำเภอเดิม จะได้ คร.6 (ใบหย่า) ใช้แต่งใหม่หรือแก้ passport ต่อได้",
    },
    {
      q: "Do I need to register my US divorce in Thailand?",
      a: "Yes, if your marriage was registered at a Thai amphur. Translate the Final Judgment or Decree Absolute, MFA-legalise, and file at the same amphur to receive Khor Ror 6 — required before remarrying or updating your Thai records.",
    },
    {
      q: "ล่ามอำเภอต้องมีใบรับรองแบบไหน?",
      a: "อำเภอส่วนใหญ่รับล่ามที่มีใบรับรองจากศาลยุติธรรมหรือกระทรวงยุติธรรม — ทีมเราทำงานร่วมกับล่ามรับรอง 12 ภาษา และประสานอำเภอ 878 แห่งล่วงหน้าเพื่อลดวันคิว",
    },
    {
      q: "K-1 fiancé visa ใช้เวลาเท่าไหร่?",
      a: "USCIS ปัจจุบัน 12–15 เดือน สำหรับ I-129F + NVC + สัมภาษณ์ที่สถานทูตกรุงเทพ — เตรียมแปล birth cert, ทะเบียนบ้าน, และหลักฐาน bona fide relationship ให้ครบตั้งแต่ต้นจะไม่โดน RFE",
    },
    {
      q: "จดสมรสที่เดนมาร์ก / ยิบรอลตาร์ ประหยัดกว่าจริงไหม?",
      a: "จริง ถ้าคู่สมรสอยู่ในยุโรปอยู่แล้ว — เดนมาร์กใช้เวลา 5 วัน, ยิบรอลตาร์ 1 วัน, และใบสมรสรับรอง Apostille กลับมาใช้ในไทยได้ทันทีตั้งแต่ ธ.ค. 2568 เป็นต้นไป",
    },
    {
      q: "แต่งงานกับคนไทยแล้วขอสัญชาติได้เมื่อไหร่?",
      a: "หลังจดสมรสและอาศัยในไทยครบ 3 ปี (ผู้ชายต่างชาติแต่งหญิงไทย) หรือ 5 ปี (หญิงต่างชาติแต่งชายไทย) มีรายได้ 40,000 บาท/เดือน ยื่นได้ที่ Special Branch ตำรวจสันติบาล — ทีมเราเตรียมแฟ้ม 47 ข้อให้ครบ",
    },
  ],
  topicTh: "จดทะเบียนสมรสไทย–ต่างชาติและแต่งงานต่างประเทศ",
  topicEn: "Thai–Foreign Marriage & Cross-Border Wedding Services",
  ctaTh:
    "ต้องการคำแนะนำเฉพาะสัญชาติ (US, UK, DE, AU, JP, KR, CN, +50 ประเทศ)? ทีมทนายให้คำปรึกษาผ่าน LINE @nyclegal ฟรี รวมถึงการจอง walk-in สถานทูตและล่ามอำเภอ",
  ctaEn:
    "Need nationality-specific guidance (US, UK, DE, AU, JP, KR, CN, +50 others)? Free consultation via LINE @nyclegal — including embassy walk-in booking and amphur interpreter coordination.",
};
